import {
  keepPreviousData,
  useMutation,
  useQuery,
  useQueryClient,
} from "@tanstack/react-query";
import { NotificationsService } from "../services/notifications.service";
import { SendNotificationDto } from "../dto/index.dto";
import { DEFAULT_LIMIT } from "../../../shared/dto/pagination.dto";

export const useGetNotificationsHook = (
  page: number,
  limit: number = DEFAULT_LIMIT
) => {
  return useQuery({
    queryKey: ["notifications", page, limit],
    queryFn: () => NotificationsService.getNotifications(page, limit),
    placeholderData: keepPreviousData,
  });
};

export const useSendNotificationHook = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: SendNotificationDto) =>
      NotificationsService.sendNotification(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["notifications"] });
    },
  });
};

export const useDeleteNotificationHook = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => NotificationsService.deleteNotification(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["notifications"] });
    },
  });
};
